import {
    get,
    post,
    execute
} from "../axios";
/**
 * 获取订单列表
 * @param {data} 
 * @return {Promise} 
 */
export const GetOrderList = data => execute('eshopapi/v1/SaleOrder/GetSearchPageData', data)
// 店铺订单列表
export const GetShopOrderList = data => execute('eshopapi/v1/ShopSaleOrder/GetSearchPageData', data)

/**
 * 取消订单
 * @param {data} 
 * @return {Promise} 
 */
export const CancelOrder = data => execute('eshopapi/v1/SaleOrder/CancelGoodsOrder', data)

/**
 * 超时取消订单
 * @param {data} 
 * @return {Promise} 
 */
export const OverTimecancelOrder = data => execute('eshopapi/v1/SaleOrder/CancelPayOverTimeGoodsOrder', data)

/**
 * 获取物流跟踪
 * @param {data} 
 * @return {Promise} 
 */
export const GetOrderLog = data => execute('EShopApi/V1/SaleOrder/GetOrderLogisticalTrackList', data)

/**
 * 获取订单取消操作记录
 * @param {data} 
 * @return {Promise} 
 */
export const GetCancelLogList = data => execute('eshopapi/v1/SaleOrder/GetOrderCancelOpLogList', data)
// 获取订单取消申请详情
export const GetOrderCancelApplyDetail = data => execute('api/v1/OrderCancelApply/GetOrderCancelApplyDetail', data)
// 撤销订单取消申请
export const RevokeOrderCancel = data => execute('api/v1/OrderCancelApply/RevokeOrderCancel', data)

/**
 * 获取取消原因
 * @param {data} 
 * @return {Promise} 
 */
export const GetCancelOrder = data => execute('eshopapi/v1/SaleOrder/GetOrderCancelReason', {})

/**
 * 获取结算价格信息接口
 * @param {data} 
 * @return {Promise} 
 */
export const GetOrderFee = data => execute('eshopapi/v1/SaleOrder/GetOrderFee', data)
// 批量获取商品详情,更新商品信息
export const GetGoodsMixList = data => execute('eshopapi/v1/SaleOrder/GetGoodsMixPrice', data)
// 店铺批量获取商品详情,更新商品信息
export const GetShopGoodsMixList = data => execute('eshopapi/v1/ShopSaleOrder/GetGoodsMixPrice', data)

/**
 * 创建订单信息接口
 * @param {data} 
 * @return {Promise} 
 */
export const CreateOrder = data => execute('eshopapi/v1/SaleOrder/CreateOrder', data)

/**
 * 查询交易单支付状态
 * @param {data} 
 * @return {Promise} 
 */
export const GetOrderPayState = data => execute('eshopapi/v1/SaleOrder/GetOrderPayState', data)

/**
 * 导出订单
 * @param {data} 
 * @return {Promise} 
 */
export const ExportExcel = data => execute('eshopapi/v1/SaleOrder/ExportExcel', data)

/**
 * 导出订单
 * @param {data} 
 * @return {Promise} 
 */
export const ShopExportExcel = data => execute('eshopapi/v1/ShopSaleOrder/ExportExcel', data)

/**
 * 完成订单
 * @param {data} 
 * @return {Promise} 
 */
export const CompleteOrderBatch = data => execute('eshopapi/v1/SaleOrder/CompleteOrderBatch', data)



/**
 * 获取订单详情（1）
 * @param {data} 
 * @return {Promise} 
 */
export const GetOrderDetail = data => execute('eshopapi/v1/SaleOrder/GetOrderDetail', data)
// 平台获取订单详情（2）
export const PtGetOrderDetail = data => execute('api/v1/SaleOrder/GetOrderDetail', data)
// 获取单个（采购）订单详情（3）
export const SingleOrderDetail = data => execute('api/v1/GoodsOrder/GetOrderDetail', data)
// 店铺订单详情
export const GetShopOrderDetail = data => execute('eshopapi/v1/ShopSaleOrder/GetOrderDetail', data)

/**
 * 获取订单支付信息（1）
 * @param {data} 
 * @return {Promise} 
 */
export const GetOrderInfoToPay = data => execute('eshopapi/v1/SaleOrder/GetOrderInfoToPay', data)
// 平台获取订单支付信息（2）
export const PtGetOrderInfoToPay = data => execute('api/v1/SaleOrder/GetOrderInfoToPay_OrderBatch', data)
// 单个订单支付信息（3）
export const SingleGetOrderInfoToPay = data => execute('api/v1/SaleOrder/GetOrderInfoToPay', data)

/**
 * 合并或单个订单支付 获取勾选订单付款信息接口（分期付款）（1）
 * @param {data} 
 * @return {Promise} 
 */
export const GetOrderPayFeeInfo = data => execute('eshopapi/V1/SaleOrder/GetOrderPayFeeInfo', data)
// 平台分期付款（2）
export const PtGetOrderPayFeeInfo = data => execute('api/V1/SaleOrder/GetOrderPayFeeInfo_OrderBatch', data)
// 单个订单分期付款（3）
export const SingleGetOrderPayFeeInfo = data => execute('api/V1/SaleOrder/GetOrderPayFeeInfo', data)

/**
 * 执行网页扫描支付接口（1）
 * @param {data} 
 * @return {Promise} 
 */
export const PageOrderPay = data => execute('eshopapi/v1/SaleOrder/PageOrderPay', data)
// 平台执行网页扫描支付接口（2）
export const PtPageOrderPay = data => execute('api/v1/SaleOrder/PageOrderPay_OrderBatch', data)
// 单个订单执行网页扫描支付（3）
export const SinglePageOrderPay = data => execute('api/v1/SaleOrder/PageOrderPay', data)

// 商城店铺 执行网页扫描支付接口（1）
export const ShopPageOrderPay = data => execute('eshopapi/V1/ShopSaleOrder/PageOrderPay', data)
// 平台店铺 执行网页扫描支付接口（2）
export const PtShopPageOrderPay = data => execute('api/V1/LimitPriceSaleOrder/PageOrderPay_OrderBatch', data)


/**
 * 支付成功后根据支付单获取订单接口（1）
 * @param {data} 
 * @return {Promise} 
 */
export const OrderSuccess = data => execute('eshopapi/v1/SaleOrder/GetOrderInfoByPayOrderNo', data)
// 平台支付成功后根据支付单获取订单接口（2）
export const PtOrderSuccess = data => execute('api/v1/SaleOrder/GetOrderInfoByPayOrderNo_OrderBatch', data)
// 单个订单支付成功后根据支付单获取订单接口（3）
export const SingleOrderSuccess = data => execute('api/v1/SaleOrder/GetOrderInfoByPayOrderNo', data)